// src/utils/loadScript.js
export default function loadScript(src, { async = true, defer = false } = {}) {
    return new Promise((resolve, reject) => {
      // don't load twice
      if (document.querySelector(`script[src="${src}"]`)) {
        return resolve(true);
      }
      const s = document.createElement('script');
      s.src = src;
      s.async = async;
      if (defer) s.defer = true;
      s.onload = () => resolve(true);
      s.onerror = (e) => reject(new Error('Failed to load ' + src));
      document.body.appendChild(s);
    });
  }
  